// A task can't become its own ancestor — the server also rejects this (400), but excluding it
// client-side avoids a round-trip for the obvious case. Used by both the task modal and the full
// task detail page's parent-task picker. Structural (not StandaloneTask directly) so it works
// equally well against the full task list or the lightweight `.../tasks/minimal` projection.
export function collectDescendantIds(taskId: string, allTasks: { _id: string; parentId?: string }[]): Set<string> {
  const children = new Map<string, string[]>();
  allTasks.forEach((t) => {
    if (!t.parentId) return;
    children.set(t.parentId, [...(children.get(t.parentId) ?? []), t._id]);
  });
  const result = new Set<string>();
  const stack = [...(children.get(taskId) ?? [])];
  while (stack.length) {
    const id = stack.pop()!;
    if (result.has(id)) continue;
    result.add(id);
    stack.push(...(children.get(id) ?? []));
  }
  return result;
}
